<div class="modal-wrapper">
  <div id="limit-container">
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <h5 class="modal-title">Límites</h5>
        </ion-col>
        <ion-col size="12">
          <p *ngIf="modeCreateLimit">Introduce los siguientes datos para crear un límite</p>
          <p *ngIf="modeEditLimit">A continuación, podrás editar algunos valores de tu límite</p>
          <p *ngIf="modeEditNoti">A continuación, podrás crear o editar una notificación para el límite. En el listado
            de sensores
            solo estarán disponibles los sensores compatibles con la propiedad seleccionada.
          </p>
          <p *ngIf="modeDelete">¿Estás seguro de que quieres eliminar el límite?</p>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="isNoti()">
        <ion-col size="12">
          <mat-form-field appearance="fill">
            <mat-label>Selecciona sensor</mat-label>
            <mat-select (selectionChange)="changeSensor($event)" [(value)]="position">
              <mat-option *ngFor="let sensor of getSensors()" [value]="sensor.position">
                Sensor {{ sensor.position }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ion-col>
      </ion-row>

      <form [formGroup]="form" (ngSubmit)="saveLimit()" #pform="ngForm">
        <ion-row *ngIf="!isDelete()">
          <ion-col *ngIf="!isNoti()" size="12">
            <mat-form-field appearance="fill">
              <mat-label>Nombre</mat-label>
              <input matInput formControlName="name">
            </mat-form-field>
          </ion-col>

          <ion-col *ngIf="!isNoti()" size="12">
            <mat-form-field appearance="fill">
              <mat-label>Propiedad</mat-label>
              <mat-select formControlName="property" (selectionChange)="selectOption($event)" [disabled]="isEdit()">
                <mat-option *ngFor="let option of options" [value]="option.value">{{ option.title }}</mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>

          <ion-col *ngIf="!isNoti()" size="12">
            <mat-form-field appearance="fill">
              <mat-label>Valor</mat-label>
              <input matInput type="number" formControlName="value">
            </mat-form-field>
          </ion-col>

          <ion-col *ngIf="!isNoti()" size="12">
            <mat-checkbox formControlName="isVisible" (change)="onChangeVisibility($event)">¿Visible en el
              gráfico?</mat-checkbox>
          </ion-col>

          <ion-col *ngIf="isNoti()" size="12">
            <mat-form-field appearance="fill">
              <mat-label>Tipo de notificación</mat-label>
              <mat-select formControlName="notificationType">
                <mat-option [value]="0">No notificar</mat-option>
                <mat-option [value]="1">Notificar si el valor es distinto al límite</mat-option>
                <mat-option [value]="2">Notificar si el valor es mayor</mat-option>
                <mat-option [value]="3">Notificar si el valor es menor</mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>

          <ion-col *ngIf="!isNoti()" size="6">
            <mat-label style="display:block">Selecciona el color</mat-label>
            <input class="limit-color" [(colorPicker)]="color" [style.background]="color" [cpOutputFormat]="'hex'"
            style="display: block; width: 100%; height: 40px; margin: 0; padding: 8px; box-sizing: border-box;"
            />
          </ion-col>

        </ion-row>

        <ion-row id="limit-container-footer">
          <ion-col size="12">
            <button *ngIf="isEdit()" type="submit" mat-raised-button color="primary"
              [disabled]="!checkValues() || isSaving">Actualizar</button>
            <button *ngIf="!isEdit() && !isDelete()" type="submit" mat-raised-button color="primary"
              [disabled]="!checkValues() || isSaving">Guardar</button>
            <button *ngIf="isDelete()" type="button" mat-raised-button (click)="deleteLimit()" class="me-3"
              color="warn">Eliminar Límite</button>
            <button type="button" mat-raised-button (click)="closeModal()" class="me-3" color="medium">Cancelar</button>
          </ion-col>
        </ion-row>
      </form>
    </ion-grid>
  </div>
</div>